import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const About = () => (
  <div className="about-page">
    {/* Заголовок */}
    <section
      className="about-header text-center py-5"
      style={{ backgroundColor: "#ECEFF1" }}
    >
      <h1 className="font-weight-bold">About myccwtt</h1>
      <p className="lead">
        Revolutionizing business travel with B2B solutions designed for seamless
        global connectivity.
      </p>
    </section>

    {/* Наша Миссия и Преимущества */}
    <section
      className="mission-section py-5"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h2 className="section-title text-primary">Our Mission</h2>
            <p className="text-muted">
              At myccwtt, we are committed to providing high-quality, efficient
              solutions for business travelers. Our mission is to enhance travel
              experiences through innovative technology, competitive pricing,
              and dedicated support.
            </p>
          </div>
          <div className="col-md-6">
            <img
              src="/images/mission.jpg"
              alt="Our Mission"
              className="img-fluid rounded shadow"
            />
          </div>
        </div>
      </div>
    </section>

    {/* Почему выбирают нас */}
    <section
      className="benefits-section py-5 text-center"
      style={{ backgroundColor: "#F0F4F8" }}
    >
      <div className="container">
        <h2 className="section-title text-primary">Why Choose myccwtt?</h2>
        <p className="lead text-muted">
          Trusted by leading companies worldwide, we provide tailored travel
          solutions and comprehensive support.
        </p>
        <div className="row">
          <div className="col-md-4">
            <i className="fa fa-rocket fa-3x mb-3 text-info" />
            <h4>Innovative Solutions</h4>
            <p className="text-muted">
              Cutting-edge tools designed to streamline corporate travel for
              optimal efficiency.
            </p>
          </div>
          <div className="col-md-4">
            <i className="fa fa-globe fa-3x mb-3 text-primary" />
            <h4>Global Reach</h4>
            <p className="text-muted">
              Extensive network across 100+ countries with seamless integration
              for all travel needs.
            </p>
          </div>
          <div className="col-md-4">
            <i className="fa fa-headphones fa-3x mb-3 text-success" />
            <h4>24/7 Support</h4>
            <p className="text-muted">
              Dedicated around-the-clock assistance for a smooth travel
              experience.
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* Технологическая Платформа */}
    <section
      className="technology-section py-5"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <img
              src="/images/technology.jpg"
              alt="Technology Platform"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6">
            <h2 className="section-title text-primary">
              Our Technology Platform
            </h2>
            <p className="text-muted">
              Adaptable and secure infrastructure designed to meet diverse
              client needs, continuously optimized for exceptional service.
            </p>
            <p className="text-muted">
              From integration with local suppliers to managing international
              distribution, our platform is built for flexibility.
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* Отзывы клиентов */}
    <section
      className="testimonials-section text-center py-5"
      style={{ backgroundColor: "#ECEFF1" }}
    >
      <h2 className="section-title text-primary">Client Testimonials</h2>
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-12 mb-4">
            <div className="testimonial-card p-4 shadow-sm rounded bg-white">
              <img
                src="https://mdbootstrap.com/img/Photos/Avatars/img%20(5).jpg"
                alt="Client Testimonial"
                className="testimonial-avatar img-fluid rounded-circle mb-3"
              />
              <h4 className="font-weight-bold">Mary Klain</h4>
              <p className="testimonial-text text-muted">
                “myccwtt has elevated our travel management to new heights,
                offering unmatched deals and superior technology.”
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 mb-4">
            <div className="testimonial-card p-4 shadow-sm rounded bg-white">
              <img
                src="https://mdbootstrap.com/img/Photos/Avatars/img%20(4).jpg"
                alt="Client Testimonial"
                className="testimonial-avatar img-fluid rounded-circle mb-3"
              />
              <h4 className="font-weight-bold">Jesica Brown</h4>
              <p className="testimonial-text text-muted">
                “Their 24/7 support and seamless integration have streamlined
                our agency’s operations tremendously.”
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 mb-4">
            <div className="testimonial-card p-4 shadow-sm rounded bg-white">
              <img
                src="https://mdbootstrap.com/img/Photos/Avatars/img%20(3).jpg"
                alt="Client Testimonial"
                className="testimonial-avatar img-fluid rounded-circle mb-3"
              />
              <h4 className="font-weight-bold">Michael Lee</h4>
              <p className="testimonial-text text-muted">
                “Working with myccwtt has allowed us to confidently expand our
                services globally.”
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Связаться с нами */}
    <section
      className="contact-section py-5 text-center"
      style={{ backgroundColor: "#FFFFFF" }}
    >
      <div className="container">
        <h2 className="section-title text-primary">Connect with Us</h2>
        <p className="lead text-muted">
          Join myccwtt’s global network and elevate your corporate travel
          experience.
        </p>
        <button className="btn btn-primary btn-lg">Contact Us</button>
      </div>
    </section>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About/about.js